<section id="section-modal" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Modals</p>

    <div class="m-t-20">
      <div class="row m-t--20">
        <div class="col-12 col-md-3 m-t-20">
          <button type="button" class="btn btn-primary w-100" (click)="openModal()">Open Modal</button>
        </div>

        <div class="col-12 col-md-3 m-t-20">
          <button type="button" class="btn btn-primary w-100" (click)="openModalCloseConfirmation()">Close Confirmation</button>
        </div>
      </div>
    </div>
  </div>
</section>
